<template>
  <Main>
    <v-container>

      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>DELETE TARGET CABANG </strong>
              </v-col>
            </v-row>
            <hr />
            <v-row style="margin-top:10px">
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_MONTH_PERIOD" :items="VSELECT_MONTH_PERIOD" label="Month Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_YEAR_PERIOD" :items="VSELECT_YEAR_PERIOD" label="Year Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="6" sm="12">
                            <v-select color="red darken-1" item-text="BRANCH_CODE" item-value="BRANCH_CODE" v-model="SELECTED_BRANCH" :items="VSELECT_BRANCH" label="Select Branch" dense outlined></v-select>
                        </v-col>
                        <v-col class="text-right" md="12">
                            <v-btn small color="warning" @click="filterDataTable()">Search</v-btn>
                        </v-col>
                    </v-row>
            <v-row>
              <v-col md="8" class="mb-2">
                  <v-layout column style="height: 50vh"> 
                      <v-flex md12 style="overflow: auto"> 
                            <v-data-table
                                :headers="dtHeaderSummary"
                                :items="dtItemSummary"
                                :loading="dtLoading"
                                loading-text="Fetching Data..."
                                :hide-default-footer="true"
                                :hide-default-header="false"
                                class="elevation-1"
                                :items-per-page="100"
                                >
                                <!-- <template v-slot:item.SumTargetHO="{ item }">
                                  <span>{{ item.SumTargetHO.toLocaleString('en-US') }}</span>
                                </template> -->
                                <template v-slot:item.SumTargetCabang="{ item }">
                                    <span>{{ new Intl.NumberFormat('en-US').format(item.SumTargetCabang) }}</span>
                                </template>
                                </v-data-table>
                            </v-flex>
                   </v-layout>
                   <div class="text--primary">
                                <v-row>
                                    <v-col md="2" sm="12"></v-col>
                                    <v-col md="2" sm="12"></v-col>
                                    <v-col md="3" sm="12"></v-col>
                                    <v-col md="3" sm="12">
                                        <tr class="right-aligned-text">
                                             <th style=" font-size: 15px;">{{ new Intl.NumberFormat('en-US').format(totals.SumTargetCabang) }}</th>
                                        </tr>
                                    </v-col>
                                </v-row>
                            </div>
              </v-col>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                    <v-data-table 
                    :headers="dtHeadersDetailTarget" 
                    :items="dtItemsDetailTarget" 
                    :search="searchRole" 
                    :loading="dtLoading" 
                    dense
                    single-expand
                    @click:row="handleClick"
                    class="elevation-1"
                    item-key="TARGET_ID"
                    loading-text="Fetching Data...">
                                  <template v-slot:item.VALUE_TGT_HO="{ item }">
                                   <span>{{ new Intl.NumberFormat('en-US').format(item.VALUE_TGT_HO) }}</span>
                                </template>
                                <template v-slot:item.VALUE_TGT_CAB="{ item }">
                                 <span>{{ new Intl.NumberFormat('en-US').format(item.VALUE_TGT_CAB) }}</span>
                                </template>
                    </v-data-table>
                    <v-row style="margin-top:10px" justify="center">
                        <v-col md="6" sm="12">
                             <v-select color="red darken-1" item-text="REASON" item-value="REASON" v-model="SELECTED_REASON" :items="VSELECT_REASON" label="Select Reason" dense outlined></v-select>
                        </v-col>
                        <v-col md="6" sm="12">
                             <v-btn @click="approve" medium class="mx-1" color="warning">Delete</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

export default {
  components: {
    Main,
  },
  data() {
    return {
      dtHeaderSummary: [
                { text: "PERIOD", value: "period" },
                { text: "POSITION", value: "ROLE_POSITION_CODE" },
                { text: "TOTAL TARGET Cabang", value: "SumTargetCabang" }
            ],
       dtHeadersDetailTarget: [{
                    text: "Month Periode",
                    value: "TGT_MONTH_ID"
                },
                {
                    text: "Year Periode",
                    value: "TGT_YEAR_ID"
                },
                {
                    text: "Cabang",
                    value: "BRANCH_CODE"
                },
                {
                    text: "Item / Subline",
                    value: "PRODUCT_SUB_LINE"
                },
                {
                    text: "Channel Outlet Group",
                    value: "OUTLET_CHANNEL_GROUP"
                },
                {
                    text: "Sales Person Position",
                    value: "ROLE_POSITION_CODE"
                },
                {
                    text: "SUM TGT Rekomendasi HO",
                    value: "VALUE_TGT_HO"
                },
                {
                    text: "SUM TGT Cabang",
                    value: "VALUE_TGT_CAB"
                }
            ],
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtItems: [],
      position: "",
      invoiceNo: "",
      openPeriod: false,
     period: moment().format("YYYY-MM"),
      userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID,
      dtItemsDetailTarget: [],
      VSELECT_MONTH_PERIOD: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      VSELECT_YEAR_PERIOD: [],
      SELECTED_BRANCH: "",
      SELECTED_REASON: "",
      SELECTED_YEAR_PERIOD: "",
      SELECTED_MONTH_PERIOD: "",
      VSELECT_BRANCH: [],
      VSELECT_REASON:[],
      dtItemSummary:[],
      dtValidPeriod: ""
    };
  },
  mounted() {
    this.cekPeriod();
    this.getReason();
    this.prepareData();
  },
  computed: {
    totals() {
      const totals = this.dtItemSummary.reduce((acc, d) => {
        acc.SumTargetHO += d.SumTargetHO
        acc.SumTargetCabang += parseInt(d.SumTargetCabang)
        return acc
      }, {
          SumTargetHO: 0,
          SumTargetCabang: 0
        })
      return totals
    }
   },
  methods: { 
    getReason() {
            this.$http
                .get("/target/selectReason", {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    const data = res.data.data;                    
                    this.VSELECT_REASON = data;                
                })
                .catch(err => {
                    this.showSnackbar(err.toString());
                });
        },
     prepareData() {
            const DATE_NOW = new Date();

            this.SELECTED_MONTH_PERIOD = DATE_NOW.getMonth() + 1;
            this.SELECTED_YEAR_PERIOD = DATE_NOW.getFullYear();

            let YEAR = [];
            for (let i = 2022; i < DATE_NOW.getFullYear() + 25; i++) {
                this.VSELECT_YEAR_PERIOD.push(i);
            }
            const USER_DATA = JSON.parse(localStorage.getItem("userData"));
            this.dtLoading = true;
            this.$http
                .get("/target/selectBranch", {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                      this.dtLoading = false;
                    const data = res.data.data;
                    if(USER_DATA.ORG_ID==81){
                        this.VSELECT_BRANCH = data;
                    }else{
                        let dataFilter = data.filter(function(e){
                          return e.ORG_ID === USER_DATA.ORG_ID
                        })   
                        this.VSELECT_BRANCH = dataFilter;
                    }                    
                })
                .catch(err => {
                    this.dtLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    filterDataTable() {
      this.dtLoading = true;
      let data = {
                MonthID: this.SELECTED_MONTH_PERIOD,
                YearID: this.SELECTED_YEAR_PERIOD,
                BranchCode: this.SELECTED_BRANCH,
                Status: ''
      };
     console.log('data ', data)
      this.$http
        .post("/target/approvalcab", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          let dataDetail = res.data.data.DetailTarget;
          let dataSum = res.data.data.resultSUMTarget;
                            dataSum.forEach((val, index) => {
                                dataSum[index].period = `${dataSum[index].TGT_YEAR_ID}-${dataSum[index].TGT_MONTH_ID}`;
                           });
          this.dtItemSummary = dataSum;
          this.dtLoading = false;
          this.dtItemsDetailTarget = dataDetail;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    handleClick(value)
    {
      console.log('valcheck ',value)
    },
    cekPeriod() {
            const userData = JSON.parse(localStorage.getItem("userData"));
              this.isLoading = true;
            let data = {
                typeID: 'TARGET',
                orgID :  userData.ORG_ID
            };
            this.$http
                .post("/setting/validPeriod", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                   this.isLoading = false;
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    this.dtValidPeriod = data.length;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    approve() { 
      if(this.dtValidPeriod>0){     
            if(this.SELECTED_REASON!==""){
            if (confirm(" Apakah Yakin akan menghapus data ini?")) {
                this.isLoading = true;
                const USER_DATA = JSON.parse(localStorage.getItem("userData"));
                let data = {
                      MonthID: this.SELECTED_MONTH_PERIOD,
                      YearID: this.SELECTED_YEAR_PERIOD,
                      BranchCode: this.SELECTED_BRANCH,
                      USER_ID : USER_DATA.USER_ID,
                      SELECTED_REASON : this.SELECTED_REASON,
                      USER_NAME : USER_DATA.USER_NAME
            };
            console.log('data ', data)
                this.$http
                  .post('/target/deletecab', data, {
                    headers: {
                      "api-key": this.$apiKey
                    }
                  })
                  .then((res) => {
                    this.isLoading = false;
                    const data = res.data;
                    if (data.success) {
                      this.showSnackbar('Success..');
                      this.selected = [];
                      this.SELECTED_REASON='';
                      this.filterDataTable();
                    } else {
                      this.showSnackbar('Something is wrong..');
                    }
                  })
                  .catch((err) => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                  });
        }

        }else{
            this.showSnackbar('Silahkan isi reason terlebih dahulu.');
        }
      }else{
          this.showSnackbar(
                  "Periode sudah ditutup."
                );
      }
      
         
			
		},
    // reject() {
    //   if (confirm(" Apakah Yakin akan lakukan Delete?")) {
    //       this.isLoading = true;
    //       this.$http
    //         .post('/target/rejectcab', this.selected, {
    //           headers: {
    //             "api-key": this.$apiKey
    //           }
    //         })
    //         .then((res) => {
    //           this.isLoading = false;
    //           const data = res.data;
    //           if (data.success) {
    //             this.showSnackbar('Success..');
    //             this.selected = [];
    //             this.filterDataTable();
    //           } else {
    //             this.showSnackbar('Something is wrong..');
    //           }
    //         })
    //         .catch((err) => {
    //           this.isLoading = false;
    //           this.showSnackbar(err.toString());
    //         });
    //   }			
		// },
  },
};
</script>
